import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CardGiftcard } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useAccountData } from '../../StorefrontThemeWrapper';
import { getGiftCardOrderPage } from '../../../utils/AccountUtils';

export const GiftCardSection = () => {
  const { t } = useTranslation();
  const { accountId, storefrontId } = useParams();
  const [searchParams] = useSearchParams();
  const account = useAccountData();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (!getGiftCardOrderPage(account)) {
    return null;
  }

  return (
    <Grid container flexDirection="column" mt={isSmallScreen ? 4 : 8} mb={isSmallScreen ? 6 : 10}>
      <Typography
        variant="h4"
        sx={{ fontWeight: 600, marginBottom: isSmallScreen ? 2 : 3, textAlign: isSmallScreen ? 'center' : 'start' }}>
        {t('storefront.giftCardSectionTitle')}
      </Typography>
      <Grid container sx={{ width: isSmallScreen ? '100%' : '50%' }}>
        <Link
          to={{ pathname: `/giftcard/${accountId}/${storefrontId || ''}`, search: searchParams.toString() }}
          style={{ textDecoration: 'none', color: 'inherit', display: 'block', width: '100%' }}>
          <Grid
            container
            alignItems="center"
            flexWrap="nowrap"
            gap={2}
            sx={{
              px: 3,
              py: 3,
              borderRadius: 2,
              border: '1px solid #e0e0e0',
              transition: 'background-color 0.15s',
              '&:hover': { backgroundColor: 'action.hover' },
            }}>
            <CardGiftcard sx={{ color: 'primary.main', fontSize: 32 }} />
            <Grid sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
                {t('storefront.giftCardTitle')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t('storefront.giftCardSectionDescription')}
              </Typography>
            </Grid>
          </Grid>
        </Link>
      </Grid>
    </Grid>
  );
};
